import { IconPlus } from "@tabler/icons-react";
import { Button, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { AddCardModal } from "./AddCardModal";

export default function AddCard() {
  const [opened, { open, close }] = useDisclosure(false);

  // TODO: Call fetchcards, and pass the url returned to the modal to open in the iframe.
  function handleModalOpen() {
    open();
  }
  return (
    <>
      <AddCardModal opened={opened} closed={close} />
      <Button variant="outline" p={4} onClick={handleModalOpen} style={{ borderColor: "#00ddb3", color: "#00ddb3" }}>
        <IconPlus />
      </Button>
    </>
  );
}
